import { produce } from 'immer';

import { ShowInternalBannerImageUploadError } from '../../../actions/imageEditor/internal/showInternalBannerImageUploadError';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function showInternalBannerImageUploadError(
    state: ImageEditorsState,
    action: ShowInternalBannerImageUploadError
): ImageEditorsState {
    const { ERROR, ENTER_LINK } = ImageOrCreativeUploadingMode;
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image.mode = draft[id].image.isUploadByLink ? ENTER_LINK : ERROR;
        draft[id].image.displayName = '';
        draft[id].image.uploadingData = undefined;
        draft[id].image.uploadProgress = 0;
        draft[id].image.errors = action.errors;

        draft[id].isImageCanvasOpen = false;
    });
}
